import { render, staticRenderFns } from "./download-certificate-form-modal.vue?vue&type=template&id=66ac6506&"
import script from "./download-certificate-form-modal.vue?vue&type=script&lang=js&"
export * from "./download-certificate-form-modal.vue?vue&type=script&lang=js&"
import style0 from "./download-certificate-form-modal.vue?vue&type=style&index=0&id=66ac6506&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports